import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';
import { useAuth } from './AuthContext';
import './Auth.css';

const Register = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { register } = useAuth();
  const { t } = useI18n();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const updateForm = (key, value) => {
    setForm((current) => ({ ...current, [key]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await register(form);
      navigate(searchParams.get('next') || '/account');
    } catch {
      setError(t('auth.register.error'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="auth-page">
      <Seo
        title={t('auth.register.title')}
        description={t('auth.register.seoDescription')}
        path="/register"
        noindex
      />
      <section className="auth-card">
        <h1>{t('auth.register.title')}</h1>
        <p>{t('auth.register.intro')}</p>
        <form className="auth-form" onSubmit={handleSubmit}>
          <label>
            {t('common.name')}
            <input
              type="text"
              value={form.name}
              onChange={(event) => updateForm('name', event.target.value)}
              autoComplete="name"
              required
            />
          </label>
          <label>
            {t('common.email')}
            <input
              type="email"
              value={form.email}
              onChange={(event) => updateForm('email', event.target.value)}
              autoComplete="email"
              required
            />
          </label>
          <label>
            {t('common.password')}
            <input
              type="password"
              value={form.password}
              onChange={(event) => updateForm('password', event.target.value)}
              autoComplete="new-password"
              minLength="8"
              required
            />
          </label>
          {error && <div className="auth-error">{error}</div>}
          <button type="submit" disabled={submitting}>
            {submitting ? t('auth.register.submitting') : t('auth.createAccount')}
          </button>
        </form>
        <div className="auth-switch">
          {t('auth.register.existingUser')} <Link to={`/login${searchParams.get('next') ? `?next=${encodeURIComponent(searchParams.get('next'))}` : ''}`}>{t('header.login')}</Link>
        </div>
      </section>
    </main>
  );
};

export default Register;
